import { convert, OKLCH, sRGB } from "@texel/color";

export function getColor(name: string): string | null {
	const root = getComputedStyle(document.documentElement);

	// Tailwind v4 colors map to --color-red-500
	const tailwindVar = `--color-${name}`;

	// DaisyUI colors map directly to --primary, --b1, etc
	const daisyVar = `--${name}`;

	const value =
		root.getPropertyValue(tailwindVar).trim() ||
		root.getPropertyValue(daisyVar).trim();

	if (!value) return null;

	// Handle OKLCH colors
	if (value.startsWith("oklch(")) {
		try {
			// Parse "oklch(65% 0.22 275)" -> [0.65, 0.22, 275]
			// Regex to capture numbers. Handles % for L.
			const match = value.match(/oklch\(([\d.]+)%?\s+([\d.]+)\s+([\d.]+)/);
			if (match) {
				// If L has %, divide by 100. If not, assume 0-1 range.
				// CSS usually uses % for L in OKLCH.
				const isPercent = value.includes("%");
				const l = Number.parseFloat(match[1]) / (isPercent ? 100 : 1);
				const c = Number.parseFloat(match[2]);
				const h = Number.parseFloat(match[3]);

				const [r, g, b] = convert([l, c, h], OKLCH, sRGB);

				return `rgb(${Math.round(r * 255)}, ${Math.round(g * 255)}, ${Math.round(b * 255)})`;
			}
		} catch (e) {
			console.warn("Failed to parse OKLCH color:", value, e);
		}
	}

	return value;
}
